export const MAIL_APNAARTIST_COLLECTIONS = {
  settings: "mail_apnaartist_settings",
  senders: "mail_apnaartist_senders",
  gmailAccounts: "mail_apnaartist_gmail_accounts",
  contacts: "mail_apnaartist_contacts",
  templates: "mail_apnaartist_templates",
  messages: "mail_apnaartist_messages",
  events: "mail_apnaartist_events",
  attachments: "mail_apnaartist_attachments",
};

export const MAIL_APNAARTIST_TABS = [
  {key: "send", label: "Send Mail"},
  {key: "manage", label: "Manage Mails"},
  {key: "monitor", label: "Monitor Mail"},
  {key: "template", label: "Template Settings"},
  {key: "leads", label: "Leads"},
];

export const MAIL_APNAARTIST_DEFAULT_SOCIALS = {
  instagram: "",
  linkedin: "",
  x: "",
  youtube: "",
};

export const MAIL_APNAARTIST_DEFAULT_TEMPLATE = {
  id: "",
  templateName: "ApnaArtist Premium Outreach",
  logoUrl: "/brand/apnaartist-cream.png",
  bannerImageUrl: "",
  bannerAlt: "ApnaArtist outreach banner",
  bannerTitle: "Create the next artist opportunity with ApnaArtist",
  bannerSubtitle: "Premium outreach crafted for institutes, brands, and creator partnerships.",
  primaryColor: "#f20c53",
  secondaryColor: "#fb6c33",
  buttonColor: "#f20c53",
  backgroundColor: "#fff7f7",
  highlights: [
    "Premium artist discovery and outreach",
    "Creator-first brand partnerships",
    "Fast coordination with the ApnaArtist team",
  ],
  footerText: "ApnaArtist helps institutions, brands, and creators build meaningful opportunities together.",
  socialLine: "Follow ApnaArtist across our active channels.",
  footerPhone: "+91 7002618625",
  footerWebsite: "https://apnaartist.com",
  footerAddress: "ApnaArtist, India",
  socialLinks: {...MAIL_APNAARTIST_DEFAULT_SOCIALS},
  showLogo: true,
  showBanner: true,
  showCta: true,
  showFooter: true,
  showHighlights: true,
  createdAt: null,
  updatedAt: null,
};

export const MAIL_APNAARTIST_DEFAULT_COMPOSER = {
  messageId: "",
  senderEmail: "",
  senderAccountId: "",
  senderConnectedEmail: "",
  senderDisplayName: "",
  senderAliasSource: "",
  senderSendReady: false,
  senderReplyToAddress: "",
  sendMode: "instant",
  scheduledSendAt: "",
  scheduledTimezone: "",
  status: "draft",
  statusNote: "",
  toText: "",
  ccText: "",
  bccText: "",
  subject: "",
  body: "Hi {{name}},\n\nWe'd love to explore a meaningful collaboration with ApnaArtist.\n\nShare your interest and we'll help shape the next step.\n\nWarm regards,\nTeam ApnaArtist",
  templateId: "",
  ctaLabel: "Explore ApnaArtist",
  ctaUrl: "https://apnaartist.com",
  attachments: [],
  attachmentNames: [],
  bannerImageUrl: "",
  bannerAlt: "ApnaArtist outreach banner",
  replyTrackingState: "reply_pending",
  gmailMessageId: "",
  gmailThreadId: "",
  failedReason: "",
};

export const MAIL_APNAARTIST_DEFAULT_LEAD = {
  id: "",
  clientName: "",
  email: "",
  phone: "",
  location: "",
  status: "new",
  mailTrackingStatus: "new",
  mailLastMessageStatus: "",
  mailLastMessageId: "",
  mailLastSentAt: null,
  mailLastOpenedAt: null,
  mailTrackingUpdatedAt: null,
};

export function ensureMailApnaArtistTemplate(input = {}) {
  const safeHighlights = Array.isArray(input.highlights) ?
    input.highlights.map((item) => String(item || "").trim()).filter(Boolean).slice(0, 3) :
    [];
  return {
    ...MAIL_APNAARTIST_DEFAULT_TEMPLATE,
    ...input,
    highlights: safeHighlights.length > 0 ?
      safeHighlights :
      [...MAIL_APNAARTIST_DEFAULT_TEMPLATE.highlights],
    socialLinks: {
      ...MAIL_APNAARTIST_DEFAULT_SOCIALS,
      ...(input.socialLinks || {}),
    },
    showLogo: input.showLogo !== false,
    showBanner: input.showBanner !== false,
    showCta: input.showCta !== false,
    showFooter: input.showFooter !== false,
    showHighlights: input.showHighlights !== false,
  };
}

export function ensureMailApnaArtistComposer(input = {}) {
  return {
    ...MAIL_APNAARTIST_DEFAULT_COMPOSER,
    ...input,
    attachments: Array.isArray(input.attachments) ? input.attachments : [],
    attachmentNames: Array.isArray(input.attachmentNames) ? input.attachmentNames : [],
  };
}

export function parseRecipientInput(value = "") {
  return String(value || "")
    .split(/[\n,;]/)
    .map((item) => item.trim())
    .filter(Boolean);
}

export function isValidEmailAddress(value = "") {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(value || "").trim());
}

export function sanitizeMailAttachmentName(value = "") {
  return String(value || "")
    .replace(/[^\w.\- ]+/g, "_")
    .replace(/\s+/g, " ")
    .trim()
    .slice(0, 120);
}

export function ensureMailApnaArtistLead(input = {}) {
  return {
    ...MAIL_APNAARTIST_DEFAULT_LEAD,
    ...input,
  };
}

export function applyMailMergeTokens(value = "", lead = {}) {
  const safeLead = ensureMailApnaArtistLead(lead);
  return String(value || "")
    .replace(/\{\{1\}\}/g, safeLead.clientName || "")
    .replace(/\{\{name\}\}/gi, safeLead.clientName || "")
    .replace(/\{\{email\}\}/gi, safeLead.email || "")
    .replace(/\{\{phone\}\}/gi, safeLead.phone || "")
    .replace(/\{\{location\}\}/gi, safeLead.location || "");
}

export function buildTemplateSnapshot(template = {}) {
  const safeTemplate = ensureMailApnaArtistTemplate(template);
  return {
    templateName: safeTemplate.templateName,
    logoUrl: safeTemplate.logoUrl,
    bannerImageUrl: safeTemplate.bannerImageUrl,
    bannerAlt: safeTemplate.bannerAlt,
    bannerTitle: safeTemplate.bannerTitle,
    bannerSubtitle: safeTemplate.bannerSubtitle,
    primaryColor: safeTemplate.primaryColor,
    secondaryColor: safeTemplate.secondaryColor,
    buttonColor: safeTemplate.buttonColor,
    backgroundColor: safeTemplate.backgroundColor,
    highlights: [...safeTemplate.highlights],
    footerText: safeTemplate.footerText,
    socialLine: safeTemplate.socialLine,
    footerPhone: safeTemplate.footerPhone,
    footerWebsite: safeTemplate.footerWebsite,
    footerAddress: safeTemplate.footerAddress,
    socialLinks: {...safeTemplate.socialLinks},
    showLogo: safeTemplate.showLogo,
    showBanner: safeTemplate.showBanner,
    showCta: safeTemplate.showCta,
    showFooter: safeTemplate.showFooter,
    showHighlights: safeTemplate.showHighlights,
  };
}

export function countTemplateReadiness(template = {}) {
  const safeTemplate = ensureMailApnaArtistTemplate(template);
  const checks = [
    Boolean(safeTemplate.templateName),
    Boolean(safeTemplate.bannerTitle),
    Boolean(safeTemplate.bannerSubtitle),
    Boolean(safeTemplate.bannerAlt),
    Boolean(safeTemplate.primaryColor),
    Boolean(safeTemplate.buttonColor),
    Boolean(safeTemplate.footerWebsite),
    Boolean(safeTemplate.footerPhone),
  ];
  const complete = checks.filter(Boolean).length;
  return Math.round((complete / checks.length) * 100);
}
